import { useEffect, useState } from 'react';

const NAV = [
  { label: '今日热榜', href: '#hot' },
  { label: '往期精选', href: '#featured' },
  { label: '合集存档', href: '#archive' },
  { label: '目录复盘', href: '#timeline' },
  { label: '分区题材', href: '#zones' },
];

export default function TopBar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'border-b border-stone-200/70 bg-[#f8f4ec]/92 shadow-[0_1px_0_rgba(0,0,0,0.02)] backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-[72px] md:px-6">
        {/* brand */}
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="53吃瓜 回到顶部">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-red-500 to-orange-400 font-serif-sc text-base font-black text-white">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-serif-sc text-xl font-black tracking-tight text-stone-900">53吃瓜</span>
            <span className="mt-1 text-[10px] tracking-widest text-stone-400">往期精选 · 合集存档</span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="rounded-full px-4 py-2 text-sm font-medium text-stone-600 transition-colors hover:bg-stone-900/5 hover:text-stone-900"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <div className="flex items-center gap-2 rounded-full border border-stone-300/70 bg-white/70 py-2 pl-3 pr-2">
            <i className="ri-search-line text-sm text-stone-400" />
            <input
              type="text"
              placeholder="搜瓜料 / 老帖编号"
              className="w-40 bg-transparent text-sm text-stone-700 outline-none placeholder:text-stone-400"
              aria-label="搜索瓜料"
            />
            <span className="whitespace-nowrap rounded-full bg-stone-900 px-2.5 py-1 text-[11px] font-medium text-white">搜索</span>
          </div>
          <a
            href="#faq"
            className="whitespace-nowrap rounded-full bg-gradient-to-r from-red-500 to-orange-400 px-5 py-2.5 text-sm font-bold text-white transition-transform hover:-translate-y-0.5"
          >
            收录说明
          </a>
        </div>

        {/* mobile toggle */}
        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-lg text-stone-700 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="切换菜单"
          aria-expanded={open}
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`} />
        </button>
      </div>

      {/* mobile panel */}
      {open ? (
        <div className="border-t border-stone-200/70 bg-[#f8f4ec] px-4 pb-5 pt-2 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-stone-700 hover:bg-stone-900/5"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#faq"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-lg bg-gradient-to-r from-red-500 to-orange-400 px-3 py-2.5 text-center text-sm font-bold text-white"
            >
              收录说明
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}